import { DEFAULT_SERP_COLORS, mixColor } from '../../../api/src/fakes/serp-appearance';
import type { Theme } from '@mui/material/styles';
import type { FakeClassification } from '../../../api/src/fakes/fakes.types';

export { SERP_CLASSIFICATION_LABELS as fakeLabels } from '../../../api/src/fakes/serp-classification';
import { SERP_CLASSIFICATION_LABELS as fakeLabels } from '../../../api/src/fakes/serp-classification';
export const fakeShortLabels: Record<FakeClassification, string> = {
  ...fakeLabels,
  owned: 'Наш',
  fake: 'Фейк',
  namesake: 'Совпадение',
  unrelated: 'Посторонний',
  external: 'Сторонний',
  unreviewed: 'Не разобрано',
  conflict: 'Конфликт',
};
export function fakeTone(theme: Theme, kind: FakeClassification) {
  return (theme.serpColors ?? DEFAULT_SERP_COLORS)[kind];
}
export const fakeDate = (value: string | null | undefined) =>
  value ? new Date(value).toLocaleString('ru-RU') : 'нет данных';
export const fakeError = (error: unknown) =>
  error instanceof Error ? error.message : 'Не удалось выполнить действие';

export const competitorTone = (theme: Theme) =>
  (theme.serpColors ?? DEFAULT_SERP_COLORS).competitor;

export const serpTextColor = (theme: Theme, accent: string) =>
  mixColor(accent, theme.palette.mode === 'dark' ? '#FFFFFF' : '#000000', 0.65);
